const name = /^$|^(?=.{1,50}$)[a-z]+\.?(?:['_.\s][a-z]+\.?)*$/i;
const email = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const password = /^$|^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-@$!%*?&])[A-Za-z\d-@$!%*?&]{12,128}$/;

export const REs = {
  name,
  email,
  password,
};
